import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, Input,
    Container,
    FormGroup,
    Row,
    Col
} from "reactstrap";
import RoleServices from "../services/RoleServices";
import UserServices from "../services/UserServices";



const User = () => {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([
        {
            id: 1,
            name: 'Administrateur'
        },
        {
            id: 2,
            name: 'Utilisateur'
        }
    ]);
    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [newUser, setNewUser] = useState({
        id: null,
        first_name: '',
        last_name: '',
        username: '',
        email: "",
        phone: "",
        role_name: "",
        password: "",
        confirmPassword: "",
        role_id: ""
    });
    const [editUser, setEditUser] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        role_name: "",
        password: ""
    });
    const [deleteUser, setDeleteUser] = useState(null);
    const navigate = useNavigate();
    const url = process.env.REACT_APP_SITE_URL;

    const access = sessionStorage.getItem('access');
    const isAdmin = access && (access.includes('admin') || access.includes('Admin'));


    useEffect(() => {
        if (!isAdmin) {
            navigate('/rapport/frontend');
        }
        const fetchUsers = async () => {
            const users = await UserServices.getUsers();
            console.log(users);
            setUsers(users);
        };
        fetchUsers();

        const fetchRoles = async () => {
            const roles = await RoleServices.getRoles();
            setRoles(roles);
        };
        fetchRoles();
    }, []);

    const isPasswordValid = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return regex.test(password);
    };

    const showRoleTitle = (roleId) => {
        const role = roles.find((r) => r.id === roleId);
        return role ? role.name : '';
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const toggleEditModal = () => {
        setEditModal(!editModal);
    };

    const toggleDeleteModal = () => {
        setDeleteModal(!deleteModal);
    };

    const handleNewUserChange = (event) => {
        setNewUser({ ...newUser, [event.target.name]: event.target.value });
    };

    const handleEditUserChange = (event) => {
        setEditUser({ ...editUser, [event.target.name]: event.target.value });
    };

    const phoneRegex = /^\d+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateFields = () => {
        if (
            newUser.first_name.trim() === "" ||
            newUser.last_name.trim() === "" ||
            newUser.username.trim() === "" ||
            newUser.email.trim() === "" ||
            newUser.phone.trim() === ""
        ) {
            setAlert("Veuillez remplir tous les champs obligatoires.");
            return false;
        }

        if (newUser.phone.trim() === "" || newUser.phone.length !== 8) {
            setAlert("Le numéro de téléphone doit avoir une longueur de 8 caractères.");
            return false;
        }

        if (!phoneRegex.test(newUser.phone)) {
            setAlert("Le numéro de téléphone ne doit contenir que des chiffres.");
            return false;
        }

        if (!emailRegex.test(newUser.email)) {
            setAlert("Veuillez entrer une adresse email valide.");
            return false;
        }

        if (!isPasswordValid(newUser.password)) {
            setMessage("");
            setAlert(
                "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un nombre, un caractère spécial et avoir une longueur minimale de 8 caractères."
            );
            return false;
        }

        return true;
    };

    const EditValidateFields = () => {

        if (editUser.username.trim() === "" || editUser.username.length < 3) {
            setAlert("Le nom d'utilisateur doit avoir une longueur d'au moins 3 caractères.");
            return false;
        }

        if (editUser.last_name.trim() === "" || editUser.last_name.length < 3) {
            setAlert("Le prénom doit avoir une longueur d'au moins 3 caractères.");
            return false;
        }

        if (editUser.first_name.trim() === "" || editUser.first_name.length < 3) {
            setAlert("Le nom doit avoir une longueur d'au moins 3 caractères.");
            return false;
        }

        if (editUser.phone.trim() === "" || editUser.phone.length !== 8) {
            setAlert("Le numéro de téléphone doit avoir une longueur de 8 caractères.");
            return false;
        }

        if (!phoneRegex.test(editUser.phone)) {
            setAlert("Le numéro de téléphone ne doit contenir que des chiffres.");
            return false;
        }

        if (editUser.email.trim() === "" || !emailRegex.test(editUser.email)) {
            setAlert("Veuillez entrer une adresse email valide.");
            return false;
        }

        return true;
    };

    const addUser = () => {
        let addedUser;
        console.log(newUser);
        console.log(roles);
        console.log('newUser');
        //const selectedRole = roles.find(role => role.id === parseInt(newUser.role_id));
        console.log(newUser);
        UserServices.addUser(newUser)
            .then(data => {
                console.log(data);
                if (data.status === 201) {
                    addedUser = data.user;
                    addedUser.role_id = Number(addedUser.role_id);
                    setUsers([...users, addedUser]);
                    setNewUser({
                        id: null,
                        first_name: "",
                        username: "",
                        last_name: "",
                        email: "",
                        role_name: "",
                        role_id: "",
                        phone: "",
                        password: "",
                        confirmPassword: "",
                    });
                    toggleModal();
                    setMessage("Utilisateur ajouté avec succès !");
                    setTimeout(() => {
                        setMessage("");
                    }, 2000); // délai de 3 secondes
                } else {
                    let message = "";
                    if (Array.isArray(data.message)) {
                        message = data.message.join(", ");
                    } else {
                        message = data.message;
                    }
                    setAlert(message);
                    setTimeout(() => {
                        setAlert("");
                    }, 2000);
                }
            })
            .catch(error => console.error(error));
    };

    const handleAddUser = () => {
        if (newUser.password !== newUser.confirmPassword) {
            setAlert("Les mots de passe ne sont pas identiques.");
        } else {
            if (validateFields()) {
                addUser();
            }
        }
    };


    const handleEditUser = () => {
        if (!EditValidateFields()) {
            return;
        }

        let updatedUser;
        // const selectedRole = roles.find(role => role.id === parseInt(editUser.role_id));
        // editUser.role_name = selectedRole.name;
        console.log(editUser);
        UserServices.updateUser(editUser)
            .then(data => {
                updatedUser = data.user;
                updatedUser.role_id = Number(updatedUser.role_id);
                // Mettre à jour le tableau users avec l'utilisateur mis à jour
                const updatedUsers = users.map(user => user.id === updatedUser.id ? updatedUser : user);
                setUsers(updatedUsers);
                console.log(updatedUser);
            })
            .catch(error => console.error(error));

        // Réinitialiser l'état editUser et fermer le modal
        setEditUser({
            id: null,
            first_name: '',
            username: '',
            last_name: '',
            email: '',
            role_id: '',
            phone: '',
            role_name: "",
            password: ''
        });
        toggleEditModal();
        setMessage("Modification effectuée avec succès !");
        setTimeout(() => {
            setMessage("");
        }, 2000); // délai de 3 secondes
    };


    const handleDeleteUser = () => {
        UserServices.deleteUser(deleteUser)
            .then(data => {
                const remainingUsers = users.filter((r) => r.id !== deleteUser.id);
                setUsers(remainingUsers);
                setDeleteUser(null);
                toggleDeleteModal();
                setMessage("Utilisateur supprimé avec succès !");
                setTimeout(() => {
                    setMessage("");
                }, 2000); // délai de 3 secondes
            })
            .catch(error => console.error(error));
    };

    return (
        <Container>
            <h1 className='my-5'>Liste des utilisateurs</h1>
            {message && <div className="alert alert-success">{message}</div>}
            {alert && <div className="alert alert-danger">{alert}</div>}
            <button className="mb-4 btn btn-success" onClick={toggleModal}>
                Ajouter un utilisateur
            </button>
            <table className="table table-striped align-middle text-center table-bordered table-hover table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Prénom</th>
                        <th>Nom</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Rôle</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            {showRoleTitle(user.role_id) ? (
                                <td>{showRoleTitle(user.role_id)}</td>
                            ) : (
                                <td>
                                    {user.role_name}
                                </td>
                            )}
                            <td>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                        setEditUser(user);
                                        toggleEditModal();
                                    }}
                                >
                                    <i className="fa-solid fa-pencil"></i>
                                </button>


                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => {
                                        setDeleteUser(user);
                                        toggleDeleteModal();
                                    }}
                                >
                                    <i className="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Modal isOpen={modal} toggle={toggleModal} className="modal-dialog modal-lg">
                <ModalHeader toggle={toggleModal}>Ajouter un utilisateur</ModalHeader>
                <ModalBody>
                    {alert && <div className="alert alert-danger">{alert}</div>}
                    <Form>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="first_name">Prénom *</Label>
                                    <Input
                                        type="text"
                                        name="first_name"
                                        id="first_name"
                                        value={newUser.first_name || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="last_name">Nom *</Label>
                                    <Input
                                        type="text"
                                        name="last_name"
                                        id="last_name"
                                        value={newUser.last_name || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="username">Nomd'utilisateur *</Label>
                                    <Input
                                        type="text"
                                        name="username"
                                        id="username"
                                        value={newUser.username || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="email">Adresse e-mail *</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={newUser.email || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="phone">Numéro de téléphone *</Label>
                                    <Input
                                        type="tel"
                                        name="phone"
                                        id="phone"
                                        value={newUser.phone || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="role_id">Rôle *</Label>
                                    <Input
                                        type="select"
                                        name="role_id"
                                        id="role_id"
                                        value={newUser.role_id || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                    >
                                        <option value="">Sélectionnez un rôle</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id}>{role.name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="password">Mot de passe *</Label>
                                    <Input
                                        type="password"
                                        name="password"
                                        id="password"
                                        value={newUser.password || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                        placeholder="Il faut 8 Caractères au minimum"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="confirmPassword">Confirmation mot de passe *</Label>
                                    <Input
                                        type="password"
                                        name="confirmPassword"
                                        id="confirmPassword"
                                        value={newUser.confirmPassword || ''}
                                        onChange={handleNewUserChange}
                                        required={true}
                                        placeholder="Il faut 8 Caractères au minimum"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddUser}>
                        Ajouter
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={editModal} toggle={toggleEditModal} className="modal-dialog modal-lg">
                <ModalHeader toggle={toggleEditModal}>Modifier l'utilisateur</ModalHeader>
                <ModalBody>
                    {alert && <div className="alert alert-danger">{alert}</div>}
                    <Form>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="first_name">Prénom *</Label>
                                    <Input
                                        type="text"
                                        name="first_name"
                                        id="first_name"
                                        value={editUser.first_name || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="last_name">Nom *</Label>
                                    <Input
                                        type="text"
                                        name="last_name"
                                        id="last_name"
                                        value={editUser.last_name || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="username">Nom d'utilisateur *</Label>
                                    <Input
                                        type="text"
                                        name="username"
                                        id="username"
                                        value={editUser.username || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="role_id">Rôle *</Label>
                                    <Input
                                        type="select"
                                        name="role_id"
                                        id="role_id"
                                        value={editUser.role_id || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    >
                                        <option value="">Sélectionnez un rôle</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id}>{role.name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="email">Adresse e-mail *</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={editUser.email || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="phone">Numéro de Téléphone *</Label>
                                    <Input
                                        type="tel"
                                        name="phone"
                                        id="phone"
                                        value={editUser.phone || ''}
                                        onChange={handleEditUserChange}
                                        required={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleEditUser}>
                        Modifier
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleEditModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Supprimer l'utilisateur</ModalHeader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer cet utilisateur ?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleDeleteUser}>
                        Supprimer
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleDeleteModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default User;
